import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";

const FormCustomErrors = () => (
  <ComponentDocs
    name="<Form.CustomErrors/>"
    entry="CustomErrorsField"
    propsEntry="CustomErrorsFieldProps"
    namespace="FormCollections"
  >
    <ComponentExample
      name="Advanced validation (multiple fields)"
      import={import("examples/Forms/FormValidation/AdvancedValidationExample")}
      rawImport={import(
        "examples/Forms/FormValidation/AdvancedValidationExample?raw"
      )}
    />
    <ComponentExample
      name="Async validation"
      import={import("examples/Forms/FormValidation/AsyncValidationExample")}
      rawImport={import(
        "examples/Forms/FormValidation/AsyncValidationExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormCustomErrors;
